import styled from 'styled-components';

export const ScTermsAndConditions = styled.div<{ isOpen: boolean }>`
  text-transform: none;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  max-width: 600px;

  & > .terms__title {
    cursor: pointer;
    display: flex;
    justify-content: center;
    gap: 8px;

    & img {
      width: 16px;
      transform: rotate(${({ isOpen }) => (isOpen ? '180deg' : '0deg')});

      transition: transform 200ms;
    }
  }

  & .terms {
    display: grid;
    grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};
    transition: grid-template-rows ${({ isOpen }) => (isOpen ? '0.4s' : '0.2s')}
      ease;

    &-content {
      overflow: hidden;
      & ol {
        padding-left: 16px;
        text-align: left;
        padding-inline-start: 20px;
        margin-top: 8px;
        & li {
          &:not(:last-child) {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
`;
